import 'css-chunksrc/client/pages/personalSpacePage/synthesis/tasks/task/styles.scss';export default {
  "task": "_task_smyzx_1",
  "wrapper": "_wrapper_smyzx_18",
  "name": "_name_smyzx_26",
  "icon": "_icon_smyzx_36",
  "taskCompletionStatus": "_taskCompletionStatus_smyzx_40",
  "status": "_status_smyzx_46",
  "statusName": "_statusName_smyzx_52",
  "endDate": "_endDate_smyzx_60",
  "late": "_late_smyzx_67",
  "breadcrumbs": "_breadcrumbs_smyzx_72",
  "separator": "_separator_smyzx_85",
  "breadcrumb": "_breadcrumb_smyzx_72",
  "taskStatus": "_taskStatus_smyzx_101",
  "constrained": "_constrained_smyzx_105",
  "constraintsPopup": "_constraintsPopup_smyzx_109"
};